<template>
  <div>
    <b-button
      id="btn-excel"
      ref="btnexcel"
      variant="primary"
      size="sm"
      style="
        margin-right: 1%;
        background: #37ef00 !important;
        border-color: #37ef00 !important;
      "
      @click="cargarReporte((excel_btn = '1'))"
    >
      <font-awesome-icon icon="fa-solid fa-file-excel" />
    </b-button>
    <b-button
      id="btn-pdf"
      variant="danger"
      size="sm"
      @click="cargarReporte((excel_btn = ''), (pdf_btn = '1'))"
    >
      <font-awesome-icon icon="fa-solid fa-file-pdf" />
    </b-button>
    <b-card-code class="principal mt-2">
      <b-row class="mt-2">
        <b-col md="4">
          <b-form-group>
            <label for="fecha-desde"
              >Fecha finalización del viaje (desde):
            </label>
            <flat-pickr
              v-model="fecha_desde"
              :config="configdateTimePicker"
              class="form-control"
              placeholder="Seleccionar fecha desde..."
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group>
            <label for="fecha-hasta"
              >Fecha finalización del viaje (hasta):
            </label>
            <flat-pickr
              v-model="fecha_hasta"
              :config="configdateTimePicker"
              class="form-control"
              placeholder="Seleccionar fecha hasta..."
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4" class="pb-2">
          <b-button variant="primary" size="sm" @click="filtrar">
            <font-awesome-icon icon="fa-solid fa-magnifying-glass" /> Consultar
          </b-button>
        </b-col>
      </b-row>
    </b-card-code>
    <b-overlay :show="mostrarLoader" opacity="0.50" rounded="sm">
      <b-card-code class="mt-1">
        <b-card-title class="mb-1 text-center"> Reporte rutas </b-card-title>
        <div id="chart">
          <vue-apex-charts
            type="bar"
            height="350"
            :options="chartOptions"
            :series="series"
            ref="barStackedChart"
          ></vue-apex-charts>
        </div>
      </b-card-code>

      <b-card-code class="mt-1">
        <b-table
          v-if="items_reporte.length > 0"
          bordered
          striped
          responsive
          :small="true"
          :items="items_reporte"
          :fields="fields_reporte"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :tbody-tr-class="rowClass"
          class="mb-1"
        >
          <template #cell(total_bus)="data">
            <a style="font-weight: bold">{{ data.value }}</a>
          </template>
        </b-table>
        <div v-else class="text-center">
          <p>No se encontraron registros</p>
        </div>
      </b-card-code>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard,
  BCardTitle,
  BCardSubTitle,
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCardBody,
  BCardHeader,
  BTooltip,
  BCardGroup,
  VBTooltip,
  BOverlay,
} from "bootstrap-vue";
import vSelect from "vue-select";
import VueApexCharts from "vue-apexcharts";
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
// import apexChatData from '@/views/charts-and-maps/charts/apex-chart/apexChartData'
import BCardCode from "@core/components/b-card-code";
import axios from "@/libs/axios";
import $ from "jquery";
import { $themeColors } from "@themeConfig";
import actions from "@/assets/utils/utils";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Spanish } from "flatpickr/dist/l10n/es.js";
import Vue from "vue";

export default {
  components: {
    VueApexCharts,
    VueSimpleSuggest,
    ValidationProvider,
    ValidationObserver,
    BCardGroup,
    BTooltip,
    BCard,
    BCardTitle,
    BCardSubTitle,
    BCardCode,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardHeader,
    BCardBody,
    flatPickr,
    vSelect,
    BOverlay,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      login_user: "",
      items_reporte: [],

      perPage: 5,
      pageOptions: [3, 5, 10],
      totalRows: 1,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      fields_reporte: [
        { key: "bus", label: "Bus", thClass: "text-center", sortable: true },
        {
          key: "aeropuerto_muelle",
          label: "Aeropuerto - Muelle",
          tdClass: "text-right",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "muelle_aeropuerto",
          label: "Muelle - Aeropuerto",
          tdClass: "text-right",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "aeropuerto_canal",
          label: "Aeropuerto - Canal",
          tdClass: "text-right",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "canal_aeropuerto",
          label: "Canal - Aeropuerto",
          tdClass: "text-right",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "total_bus",
          label: "Total",
          tdClass: "text-right",
          thClass: "text-center",
          sortable: true,
        },
      ],
      items: [],
      mostrarLoader: false,
      fecha_desde: new Date().toLocaleString("pt-BR").split(", ")[0],
      fecha_hasta: new Date().toLocaleString("pt-BR").split(", ")[0],
      configdateTimePicker: {
        enableTime: false,
        dateFormat: "d/m/Y",
        locale: Spanish,
      },

      series: [],
      chartOptions: {
        chart: {
          type: "bar",
          height: 350,
          stacked: true,
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              total: {
                enabled: true,
                offsetX: 0,
                style: {
                  fontSize: "13px",
                  fontWeight: 900,
                },
              },
            },
          },
        },
        stroke: {
          width: 1,
          colors: ["#fff"],
        },
        title: {
          text: "",
        },
        xaxis: {
          categories: [],
          labels: {
            formatter: function (val) {
              return val;
            },
          },
        },
        yaxis: {
          title: {
            text: undefined,
          },
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val;
            },
          },
        },
        fill: {
          opacity: 1,
        },
        legend: {
          position: "top",
          horizontalAlign: "left",
          offsetX: 40,
        },

        colors: [
          "#6CADDF",
          "#E194BC",
          "#FAB26A",
          "#AE77B2",
          "#F27077",
          "#9DD374",
          "#DA8868",
          "#DC69AA",
          "#6978AA",
          "#939393",
        ],
      },
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
  },
  created() {
    this.comprobarPermisos();
    $("#btn-excel").remove();
    $("#btn-pdf").remove();
    $("#btn-print").remove();
    $("#eliminar-viajes").remove();
    $("#btn-abrir-caja").remove();
    this.setToken();
    // this.cargarCantidadxTipoPasajero()
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
    // this.cargarCantidadMarcacionXAnio()
    this.cargarReporte();
    $("#contenedor-botones").append($("#btn-excel")).append($("#btn-pdf"));
  },
  methods: {
    comprobarPermisos() {
      if (localStorage.getItem("permisos").indexOf("rep_reporte_ruta") === -1) {
        this.$router.push({ name: "not-permitted" });
      }
    },
    filtrar() {
      this.cargarReporte();
    },
    cargarReporte(excel_btn = "", pdf_btn = "") {
      this.mostrarLoader = true;
      axios
        .post("api", {
          query: `query getReporteRutas($fechaDesde: String!, $fechaHasta: String!, $excel: String!, $pdf: String!){
                    getReporteRutas(fechaDesde: $fechaDesde, fechaHasta: $fechaHasta, excel: $excel, pdf: $pdf){
                        reporteRuta{
                            bus,
                            aeropuerto_muelle: aeropuertoMuelle,
                            muelle_aeropuerto: muelleAeropuerto,
                            aeropuerto_canal: aeropuertoCanal,
                            canal_aeropuerto: canalAeropuerto,
                            total_bus: totalBus,
                        },
                        reporteparagrafica{
                            nombresBuses: nombresBuses,
                            rutasCantidades{
                                aeropuertoMuelle{
                                    nombre,
                                    cantidades,
                                },
                                muelleAeropuerto{
                                    nombre,
                                    cantidades,
                                },
                                aeropuertoCanal{
                                    nombre,
                                    cantidades,
                                },
                                canalAeropuerto{
                                    nombre,
                                    cantidades,
                                },
                            },
                        },
                        dataarchivo,
                        status,
                        message,
                    }
                }`,
          variables: {
            fechaDesde: this.fecha_desde,
            fechaHasta: this.fecha_hasta,
            excel: excel_btn,
            pdf: pdf_btn,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.data.getReporteRutas.status === "success") {
              if (response.data.data.getReporteRutas.reporteRuta) {
                this.items_reporte =
                  response.data.data.getReporteRutas.reporteRuta;
                this.items_reporte[this.items_reporte.length - 1]["status"] =
                  "negrita";
              } else {
                var data = response.data.data.getReporteRutas.dataarchivo;
                if (excel_btn === "1") {
                  actions.cargarArchivos(
                    data,
                    "Reporte Rutas.xlsx",
                    "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64"
                  );
                } else {
                  actions.cargarArchivos(
                    data,
                    "Reporte Rutas.pdf",
                    "data:application/pdf;base64"
                  );
                }
              }
              if (response.data.data.getReporteRutas.reporteparagrafica) {
                let customSeries = [];
                let reporte =
                  response.data.data.getReporteRutas.reporteparagrafica
                    .rutasCantidades;
                for (var key in reporte) {
                  let tarifa = {
                    name: reporte[key]["nombre"],
                    data: reporte[key]["cantidades"],
                  };
                  customSeries.push(tarifa);
                }
                this.$refs.barStackedChart.updateOptions({
                  series: customSeries,
                  xaxis: {
                    categories:
                      response.data.data.getReporteRutas.reporteparagrafica
                        .nombresBuses,
                  },
                });
              }
            }
          }
          this.mostrarLoader = false;
        });
    },
    rowClass(item, type) {
      const styleClass = "last-row";
      if (!item || type !== "row") {
        return;
      }

      // eslint-disable-next-line consistent-return
      if (item.status === "negrita") {
        return styleClass;
      }
    },
    setToken() {
      const usuarioCookie = this.$cookie.get("usuario");
      if (usuarioCookie != null) {
        const user = JSON.parse(usuarioCookie);
        this.login_user = user.username;
        axios.defaults.headers.common.Authorization = `JWT ${user.token}`; // for all requests
      }
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>

<style>
.text-red {
  color: red;
}
.last-row {
  font-weight: bold !important;
}
.principal .card-header {
  display: none !important;
}
.principal .card-body {
  padding-bottom: 0 !important;
}
[dir] .table th,
[dir] .table td {
  padding-left: 1%;
  padding-right: 1%;
}
</style>
